import { render } from "./MainChat.vue?vue&type=template&id=de432e10&scoped=true"
import script from "./MainChat.vue?vue&type=script&lang=js"
export * from "./MainChat.vue?vue&type=script&lang=js"

import "./MainChat.vue?vue&type=style&index=0&id=de432e10&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de432e10"]])

export default __exports__